import { z } from "zod/v4";

export const memberNoteSchema = z.object({
	id: z.string().uuid(),
	member_id: z.string().uuid(),
	author_id: z.string().uuid(),
	content: z.string(),
	created_at: z.coerce.date(),
	updated_at: z.coerce.date(),
});

export type MemberNote = z.infer<typeof memberNoteSchema>;
